<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	import EuroWatermark from '$lib/assets/images/icons/euro-watermark.svg?component';
	import __ from '$lib/stores/TranslationStore';
	export let baseColor: string = 'primary';
	export let title: string;
	export let caption: string | null = null;
	export let bottomText: string = $__('Mensalidade');
	export let amount: number = 0;
	let className: string = '';
	export { className as class };

	$: integerPart = Math.trunc(amount);
	$: decimalPart = String((Math.trunc(amount * 100) / 100).toFixed(2))
		.split('.')
		.slice(-1);

	let aside: HTMLElement;
	$: asideWidth = aside?.offsetWidth ?? 0;
</script>

<div
	class={twMerge(
		`bg-${baseColor}-light relative flex h-auto flex-col justify-between gap-5 rounded-xl p-4 text-slate md:flex-row lg:h-[220px] lg:px-9 lg:py-6`,
		className
	)}
>
	<slot name="euromark">
		{#if !$$slots.values}
			<EuroWatermark
				class="absolute bottom-4 right-4 h-28 fill-black opacity-50 lg:bottom-6 lg:right-9 lg:h-[140px]"
			/>
		{:else}
			<div style:right={asideWidth + 35 + 'px'} class="absolute bottom-4 lg:bottom-6">
				<EuroWatermark class="hidden h-28 fill-black opacity-50 md:block lg:h-[140px]" />
			</div>
		{/if}
	</slot>
	<div class="flex flex-1 flex-col justify-between gap-3">
		<div class="whitespace-nowrap text-sm text-white">
			<h2>
				<span class="bg-{baseColor} px-1 font-semibold"> {title} </span>
			</h2>
			{#if caption}
				<h2>
					<span class="bg-{baseColor} px-1"> {caption} </span>
				</h2>
			{/if}
		</div>
		<slot integerPart={integerPart.toLocaleString('pt-BR')} {decimalPart} {bottomText}>
			<div class="flex flex-col gap-3">
				<div class="flex justify-start gap-1">
					<em class="text-5xl not-italic tracking-tighter sm:text-5xl lg:text-[100px]"
						>{integerPart.toLocaleString('pt-BR')}</em
					>
					<span class="text-xl sm:text-2xl lg:mt-[5px] lg:text-4xl xl:text-5xl">,{decimalPart}</span
					>
				</div>
				<p class="text-xs font-semibold uppercase tracking-widest lg:text-base">{bottomText}</p>
			</div>
		</slot>
	</div>

	<aside bind:this={aside}>
		<slot name="values" />
	</aside>
</div>
